$ = require 'jquery'
_ = require 'underscore'
f = require 'effing'
React = require 'react'
Promise = require 'bluebird'
Util = require 'app/scripts/lib/util'
Layout = require 'app/scripts/views/lib/layout'
PopOver = require 'app/scripts/views/lib/pop-over'
AttachmentTypePickerView = require 'app/scripts/views/card/attachment-type-picker-view'
{ track, trackUe } = require '@trello/analytics'
TrelloCompleterView = require 'app/scripts/views/internal/autocomplete/trello-completer-view'
UploadingLinkView = require 'app/scripts/views/card/uploading-link-view'
LimitExceeded = require 'app/scripts/views/attachment/attachment-limit-exceeded-error'
Alerts = require 'app/scripts/views/lib/alerts'
AttachmentHelpers = require 'app/scripts/views/attachment/helpers'
PluginRunner = require 'app/scripts/views/internal/plugins/plugin-runner'
PluginModelSerializer = require 'app/scripts/views/internal/plugins/plugin-model-serializer'
{ PowerUpSuggestionContainer, getClaimedSecondLevelDomainsToPluginMapForOrg, doesMatchClaimedDomain, getSecondLevelDomain } = require 'app/src/components/PowerUpAttachmentSectionSuggestion'
pluginValidators = require 'app/scripts/lib/plugins/plugin-validators'
PluginSectionView = require 'app/scripts/views/plugin/plugin-section-view'
{ sendPluginScreenEvent } = require 'app/scripts/lib/plugins/plugin-behavioral-analytics'
{ renderComponent } = require 'app/src/components/ComponentWrapper'
InProgressAttachmentView = require 'app/scripts/views/attachment/in-progress-attachment'
l = require 'app/scripts/lib/localize'
TrelloBoardAttachment = require 'app/scripts/views/attachment/trello-board-attachment'
TrelloCardAttachment = require 'app/scripts/views/attachment/trello-card-attachment'
AttachmentThumbView = require 'app/scripts/views/attachment/attachment-thumb-view'
pastedFileName = require 'app/scripts/views/internal/pasted-file-name'
warnIfFileTooLarge = require 'app/scripts/views/internal/warn-if-file-too-large'
ninvoke = require 'app/scripts/lib/util/ninvoke'
parseTrelloUrl = require 'app/scripts/lib/util/url/parse-trello-url'
DragSort = require 'app/scripts/views/lib/drag-sort'

module.exports.incrementNumAttachmentsProcessing = (count = 1) ->
  @numAttachmentsProcessing.update f.add(count)

module.exports.decrementNumAttachmentsProcessing = (count = 1) ->
  @numAttachmentsProcessing.update f.sub(count)

module.exports.incrementNumTrelloAttachmentsProcessing = (count = 1) ->
  @numTrelloAttachmentsProcessing.update f.add(count)

module.exports.decrementNumTrelloAttachmentsProcessing = (count = 1) ->
  @numTrelloAttachmentsProcessing.update f.sub(count)

module.exports.attachComment = (e) ->
  file = new Blob([@$('.js-new-comment-input').val()], { type: 'text/plain' })
  @incrementNumAttachmentsProcessing()
  @model.upload file, 'comment.txt', @callback =>
    @decrementNumAttachmentsProcessing()

  @clearComment()
  Layout.cancelEdits()
  @collapseComment()

module.exports.openAttachPicker = (e) ->
  Util.stop(e)

  elem = $(e.target).closest('.js-attach')

  PopOver.toggle
    elem: elem
    view: AttachmentTypePickerView
    options: {
      @model
      @modelCache
      onStartUpload: (card, type) =>
        if type == 'card' || type == 'board'
          @incrementNumTrelloAttachmentsProcessing()
        else
          @incrementNumAttachmentsProcessing()
      onFinishUpload: @callback (card, type) =>
        if type == 'card' || type == 'board'
          @decrementNumTrelloAttachmentsProcessing()
        else
          @decrementNumAttachmentsProcessing()
    }

  type = if $(elem).hasClass('inline')
    "Inline"
  else if $(elem).hasClass('quiet-button')
    "Quiet"
  else
    "Sidebar"
  track("Card Detail", "Open Attachment Type Picker", "Via #{type} Button", @model.trackProperty())

  false

module.exports.openAttachTrelloPicker = (e) ->
  Util.stop(e)

  elem = $(e.target).closest('.js-attach-trello-attachment')
  track("Card Detail", "Open Trello Attachment Picker", "Via Trello Attachments Section", @model.trackProperty())

  PopOver.toggle
    elem: elem
    view: TrelloCompleterView
    options: {
      @model
      @modelCache
      card: @model
      button: true
      onStartUpload: (card) =>
        @incrementNumTrelloAttachmentsProcessing()

        PopOver.pushView
          view: UploadingLinkView

        url = card.get('url')
        Promise.fromNode (next) => @model.uploadUrl(url, next)
        .catch LimitExceeded, =>
          Alerts.show("unable to attach card or board", 'error', 'trelloattachment', 5000)
        .then ->
          PopOver.popView()
        .finally =>
          @decrementNumTrelloAttachmentsProcessing()
    }

  false

module.exports.renderAddAttachments = ->
  disabled = !@model.canAttach()
  @$('.js-attach,.js-attach-trello-attachment,.js-attach-link')
    .toggleClass('disabled', disabled)

  @

module.exports.showFewerAttachments = (e) ->
  Util.stop(e)
  @fShowAllAttachments = false
  @renderAttachments()
  return

module.exports.showMoreAttachments = (e) ->
  Util.stop(e)
  @fShowAllAttachments = true
  @renderAttachments()
  return

module.exports.showFewerTrelloAttachments = (e) ->
  Util.stop(e)
  @fShowAllTrelloAttachments = false
  @renderAttachments()
  return

module.exports.showMoreTrelloAttachments = (e) ->
  Util.stop(e)
  @fShowAllTrelloAttachments = true
  @renderAttachments()
  return

module.exports.renderAttachments = ->
  @_renderAttachmentsPromise?.cancel()

  allAttachments = _.clone(@model.attachmentList.models).reverse()

  board = @model.getBoard()
  availablePlugins = board.getAvailablePlugins()

  @_renderAttachmentsPromise = Promise.all([
    Promise.all(allAttachments.map(AttachmentHelpers.getAttachmentData)),

    Promise.try =>
      if allAttachments.length > 0
        PluginRunner.all
          timeout: 5000
          command: 'attachment-sections'
          card: @model
          board: @model.getBoard()
          options:
            entries: PluginModelSerializer.attachments(allAttachments)
      else
        []
    .cancellable(),

    Promise.try( =>
      if allAttachments.length > 0
        return getClaimedSecondLevelDomainsToPluginMapForOrg(board.get('idOrganization'), board.id)
    )
  ])
  .spread (allAttachmentData, pluginAttachmentSections, domainsMap) =>
    displayedInSection = {}
    usedSubviewIds = {}

    subviews = _.chain(pluginAttachmentSections)
      .filter (section) => pluginValidators.isValidAttachmentSections(section, @model.attachmentList)
      .map (section) =>
        _.forEach section.claimed, (entry) ->
          displayedInSection[entry.id] = true

        subviewId = section.id || section.title
        if _.isFunction(subviewId) || usedSubviewIds[subviewId]
          subviewId = _.uniqueId('attachment-section_')
        usedSubviewIds[subviewId] = true
        subview = @subview PluginSectionView, @model, {}, subviewId
        subview.updateSection(section)
        subview
      .value()

    trelloAttachments = @getTrelloAttachments(allAttachments, allAttachmentData, displayedInSection)
    trelloAttachments.forEach(({ attachment }) -> displayedInSection[attachment.id] = true)

    idPlugins = _.chain(pluginAttachmentSections).pluck('idPlugin').uniq().value()
    for idPlugin in idPlugins
      trackUe('card details', 'views', 'Power-Up', '', '', 'attachment-sections', idPlugin)

    $pluginSections = @$('.js-plugin-sections')
    @ensureSubviews(subviews, $pluginSections)

    # render the PASS views
    suggestionSectionsToRender = {}
    # for each attachment that's not been claimed by another attachment section
    # see if attachment's url's second level domain matches any in domain map
    # if so, check the attachment's url against that plugin's claimedDomains
    # then add this attachment to that plugin's PASS section on the card back
    allAttachmentData.forEach (attachment) =>
      if displayedInSection[attachment.id]
        return

      # grab second-level domain, e.g 'https://na36.salesforce.com/008' to 'salesforce.com'
      attachmentDomain = getSecondLevelDomain(attachment.url)

      possiblePlugins = domainsMap[attachmentDomain]
      if !possiblePlugins || possiblePlugins.length == 0
        return

      # which of the possible plugins actually matches, if any
      plugin = possiblePlugins.find (plugin) ->
        plugin.get('claimedDomains').some (domain) ->
          doesMatchClaimedDomain(attachment.url, domain)

      if !plugin || !board.shouldRenderPluginSuggestionSection(plugin.id)
        return

      displayedInSection[attachment.id] = true
      pluginName = plugin.get('name')
      if suggestionSectionsToRender[plugin.id]
        suggestionSectionsToRender[plugin.id].attachments.push(attachment)
      else
        suggestionSectionsToRender[plugin.id] =
          attachments: [attachment]
          name: pluginName
          overview: plugin.get('listing').overview
          mark: plugin.get('icon').url
          onRemoveAttachment: (idAttachment) -> allAttachments.find((a) -> a.id == idAttachment)?.destroy()
          onDismissBtn: (target) => @dismissPluginSuggestionSection(target.closest('button'), plugin.id)
          onEnableBtn: (target) => @enableSuggestedPluginPrompt(target.closest('button'), plugin)

    if !@trackedSuggestionSections then @trackedSuggestionSections = {}
    Object.keys(suggestionSectionsToRender).forEach (idSuggestedPlugin) =>
      # prevent double tracking on re-renders of attachments
      if !@trackedSuggestionSections[idSuggestedPlugin]
        @trackedSuggestionSections[idSuggestedPlugin] = true
        sendPluginScreenEvent(idSuggestedPlugin, 'pupAttachmentSuggestionSection')

    renderComponent(
      React.createElement(
        PowerUpSuggestionContainer,
        { suggestionProps: Object.values(suggestionSectionsToRender) },
      ),
      @$('.js-plugin-suggestion-sections')[0]
    )

    initialNumToShow = 4
    numShown = 0
    remainingAttachments = []

    for i, attachment of allAttachments
      if numShown == initialNumToShow or numShown == allAttachments.length
        break

      remainingAttachments.push(attachment)

      if not displayedInSection.hasOwnProperty(attachment.id)
        numShown++

    nonPluginAttachments = _.reject allAttachments, (attachment) ->
      displayedInSection[attachment.id]

    hasAttachments = numShown > 0
    hasOverflow = numShown < nonPluginAttachments.length

    $attachmentsSection = @$('.js-attachments-section')
    $trelloAttachmentsSection = @$('.js-trello-attachments-section')
    $attachmentsList = $attachmentsSection.find('.js-attachment-list')

    trelloAttachmentSubviews =
      if (processingTrelloAttachmentsCount = @numTrelloAttachmentsProcessing.get())
        _.times Math.min(3, processingTrelloAttachmentsCount), (index) =>
          @subview InProgressAttachmentView, @model, null, "processing-trello-attachment-#{ index }"
      else
        []

    if trelloAttachments.length > 0
      numHiddenTrelloAttachments = (trelloAttachments.length - initialNumToShow).toString()

      if numHiddenTrelloAttachments > 0
        if not @fShowAllTrelloAttachments
          trelloAttachments = trelloAttachments.splice(0, initialNumToShow)

          $trelloAttachmentsSection.find('.js-show-more-trello-attachments').removeClass('hide')
          $trelloAttachmentsSection.find('.js-show-fewer-trello-attachments').addClass('hide')
          $trelloAttachmentsSection.find('.js-view-all-trello-attachments').text l('view all trello attachments', {
            hiddenCount: numHiddenTrelloAttachments
          })
        else
          $trelloAttachmentsSection.find('.js-show-more-trello-attachments').addClass('hide')
          $trelloAttachmentsSection.find('.js-show-fewer-trello-attachments').removeClass('hide')
      else
        $trelloAttachmentsSection.find('.js-show-more-trello-attachments').addClass('hide')
        $trelloAttachmentsSection.find('.js-show-fewer-trello-attachments').addClass('hide')

      trelloAttachmentSubviews = trelloAttachmentSubviews.concat(
        trelloAttachments.map ({ attachment, attachmentData }) =>
          if attachmentData.type == 'trello card'
            @subview TrelloCardAttachment, attachment, { cardUrl: attachmentData.url }
          else
            @subview TrelloBoardAttachment, attachment, { boardUrl: attachmentData.url }
      )

    @ensureSubviews(trelloAttachmentSubviews, @$('.js-trello-attachments-list'))
    $trelloAttachmentsSection.toggleClass('hide', _.isEmpty(trelloAttachmentSubviews))

    @$('.js-show-with-attachments').toggleClass('hide', !hasAttachments )

    @enableAttachmentSorting($attachmentsList)

    hiddenCount = (nonPluginAttachments.length - initialNumToShow).toString()
    $attachmentsSection.find('.js-view-all-attachments').text l('view all attachments', { hiddenCount })
    $attachmentsShowFewer = $attachmentsSection.find('.js-show-fewer-attachments').addClass('hide')
    $attachmentsShowMore = $attachmentsSection.find('.js-show-more-attachments').addClass('hide')

    processingSubviews =
      if (processingCount = @numAttachmentsProcessing.get())
        _.times Math.min(3, processingCount), (index) =>
          @subview InProgressAttachmentView, @model, null, "processing-#{ index }"
      else
        []

    attachmentSubviews =
      if hasAttachments
        attachmentModels = allAttachments

        if hasOverflow
          if !@fShowAllAttachments
            $attachmentsShowMore.removeClass('hide')
            attachmentModels = remainingAttachments
          else
            $attachmentsShowFewer.removeClass('hide')

        attachmentModels.map (attachment) =>
          if displayedInSection.hasOwnProperty(attachment.id)
            return

          @subview AttachmentThumbView, attachment, {
            onReply: => @replyToAttachment(attachment)
            onPluginThumbnail: (idPlugin) =>
              if !@pluginThumbTrackCache[idPlugin]
                @pluginThumbTrackCache[idPlugin] = true
                trackUe('card details', 'views', 'Power-Up', '', '', 'attachment-thumbnail', idPlugin)
          }
      else
        []

    subviews = _.compact [processingSubviews..., attachmentSubviews...]
    @ensureSubviews(subviews, $attachmentsList)

    $attachmentsSection.toggleClass('hide', _.isEmpty(subviews) )

  .catch Promise.CancellationError, (->)

  @_renderAttachmentsPromise.done()
  @

module.exports.dragenter = (e) ->
  if !@model.editable()
    return

  limited = false
  restricted = !@model.canDropAttachment(e.type)

  if restricted
    classname = '.attachments-restricted'
  else if @model.isOverLimit('attachments', 'perCard')
    className = '.attachments-per-card'
    limited = true
  else if @model.getBoard().isOverLimit('attachments', 'perBoard')
    className = '.attachments-per-board'
    limited = true
  else
    className = '.dropzone'

  _scrollTop = $('.window-overlay').scrollTop() + 200

  @$(className).css
    'padding-top': "#{_scrollTop}px"
  @$el
  .addClass('is-drophover')
  .toggleClass('is-limited', limited)
  .toggleClass('is-restricted', restricted)

module.exports.dragleave = (e) ->
  @$el.removeClass('is-drophover')

module.exports.dropFiles = (e) ->
  if !@model.canAttach() || @model.attachmentTypeRestricted('computer')
    return

  track("Card Detail", "Drop Attachment Upload")
  files = e.detail

  if warnIfFileTooLarge(@model.getBoard(), files)
    return

  @incrementNumAttachmentsProcessing(files.length)

  processed = 0
  Promise.resolve(files)
  .each (file) =>
    name = file.name || pastedFileName()
    ninvoke @model, 'upload', file, name
    .finally @callback =>
      processed++
      @decrementNumAttachmentsProcessing()
  .catch ->
    Alerts.show("unable to upload file", 'error', 'upload', 5000)
  .finally =>
    if processed != files.length
      @decrementNumAttachmentsProcessing(files.length - processed)
  .done()

  e.stopPropagation()

module.exports.dropUrl = (e) ->
  if !@model.canAttach()
    return

  track("Card Detail", "Drop Attachment Url", undefined, @model.trackProperty())
  url = e.detail

  board = @model.getBoard()
  if board.attachmentUrlRestricted(url)
    return

  isTrelloAttachment = parseTrelloUrl(url).type in ['board', 'card']

  if isTrelloAttachment
    @incrementNumTrelloAttachmentsProcessing()
  else
    @incrementNumAttachmentsProcessing()

  @model.uploadUrl url, @callback =>
    if isTrelloAttachment
      @decrementNumTrelloAttachmentsProcessing()
    else
      @decrementNumAttachmentsProcessing()

  e.stopPropagation()

module.exports.enableAttachmentSorting = ($attachmentsList) ->
  if @model?.editable()
    DragSort.refreshCardSortable $attachmentsList,
      axis: 'y'
      handle: [
        '.attachment-thumbnail-details'
        '.attachment-thumbnail-preview'
      ].join(',')
      delay: 75
      distance: 7
      tolerance: 'pointer'
      helper: 'clone'
      placeholder: 'attachment-thumbnail placeholder'
      items: '.attachment-thumbnail'
      start: (event, ui) ->
        _height = $(ui.helper).outerHeight()
        $(ui.placeholder).height(_height)

module.exports.getTrelloAttachments = (attachments, allAttachmentData, claimedAttachments) ->
  attachmentTypes = ['trello board', 'trello card']

  attachments.map((attachment, i) =>
    attachmentData = allAttachmentData[i]
    if attachmentData.isKnownService and attachmentData.type in attachmentTypes and !claimedAttachments[attachment.id]
      { attachment, attachmentData }
    else
      null
  ).filter((a) => a != null)

module.exports.sortStopAttachments = (e, ui) ->
  Util.stopPropagation(e)
  ui.item.trigger('moveattachment', [ui])
